"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _DebugManager = _interopRequireDefault(require("../utils/DebugManager"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var dmInstance = _DebugManager["default"].dmInstance;
var LoggerUtil = function LoggerUtil(store) {
  return function (next) {
    return function (action) {
      var debug = store.getState().debug.debug;
      dmInstance.logMessage([_DebugManager["default"].debugLevel.A], 'Redux action: ', action);
      next(action);
    };
  };
};
var _default = exports["default"] = LoggerUtil;